module.exports = __webpack_public_path__ + "static/media/CCTP - Science Module (v3) -ENG.b4e4971f.pptx";